var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackBtnBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#00A6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7054 21.2946C19.0947 20.9053 19.095 20.2743 18.7062 19.8846L15.5348 16.7063C15.1453 16.316 15.1453 15.684 15.5348 15.2937L18.7062 12.1154C19.095 11.7257 19.0947 11.0947 18.7054 10.7054C18.3158 10.3158 17.6842 10.3158 17.2946 10.7054L12.7071 15.2929C12.3166 15.6834 12.3166 16.3166 12.7071 16.7071L17.2946 21.2946C17.6842 21.6842 18.3158 21.6842 18.7054 21.2946Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtnBlue);
export default __webpack_public_path__ + "static/media/back-btn-blue.22804d9a766661da2af9d08f49515dcd.svg";
export { ForwardRef as ReactComponent };